import GATSBY_COMPILED_MDX from "/opt/build/repo/src/content/articles/blog/health-insurance.mdx";
import React from 'react';
import {Box, Typography} from '@mui/material';
import {Layout} from '../components/Layout';
import {Header} from '../containers/Header';
import {Footer} from '../containers/Footer';
import {CommonHead} from '../components/CommonHead';
import {Section} from '../components/Section';
import {ArticleBody} from '../components/ArticleBody';
import {ArticleHeader} from '../components/ArticleHeader';
import {ArticleTableOfContents} from '../components/ArticleTableOfContents';
import {ArticleScrollHeadingProvider, useArticleScrollHeading} from '../components/ArticleScrollHeadingProvider';
import {SectionContentArticles} from '../components/SectionContentArticles';
import {SectionContentMetrics} from '../components/SectionContentMetrics';
import {GatedArticle} from '../contexts/articles/components/GatedArticle';
import {StructuredData} from '../components/StructuredData';
import {generateStructuredDataForArticle} from '../contexts/seo/schemas/article';
import {isGatedContent} from '../utils/articles';
import {cloudinaryImage} from '../cloudinary';
import {jsx as ___EmotionJSX} from "@emotion/react";
const ArticleBodyWithToc = ({children}) => {
  const {contentRef} = useArticleScrollHeading();
  return ___EmotionJSX(Box, {
    ref: contentRef,
    sx: {
      flex: 1
    }
  }, ___EmotionJSX(ArticleBody, null, children));
};
const ArticleTemplate = ({data, children}) => {
  const article = data.mdx.frontmatter;
  const related = data.related.nodes.map(n => n.frontmatter);
  const hero = article.heroImage;
  return ___EmotionJSX(Layout, {
    header: ___EmotionJSX(Header, null)
  }, ___EmotionJSX(ArticleScrollHeadingProvider, null, isGatedContent(article) ? ___EmotionJSX(GatedArticle, {
    article: article
  }, children) : ___EmotionJSX(Box, null, ___EmotionJSX(Section, {
    backgroundColor: "light-gray",
    padding: 50
  }, ___EmotionJSX(Box, {
    sx: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, ___EmotionJSX(Typography, {
    variant: "button",
    sx: {
      fontSize: '0.875rem',
      borderRadius: '2px',
      backgroundColor: theme => theme.app.neon,
      padding: '2px 8px'
    }
  }, article.category), ___EmotionJSX(Typography, {
    variant: "t1",
    component: "h1",
    sx: [{
      textTransform: 'uppercase'
    }, theme => ({
      fontSize: {
        xs: '2.25rem',
        sm: '2.25rem',
        lg: theme.typography.t1.fontSize
      }
    })]
  }, article.headline))), hero && ___EmotionJSX(Section, {
    prerender: true,
    cloudinaryBackground: {
      publicId: hero.publicId,
      alt: hero.alt
    }
  }, ___EmotionJSX(Box, {
    sx: {
      minHeight: {
        xs: 170,
        md: 250,
        xl: 500
      }
    }
  })), ___EmotionJSX(Box, {
    sx: [{
      display: 'flex',
      alignItems: 'start'
    }, theme => ({
      ...theme.mixins.constrainWidth,
      gap: {
        xs: 2,
        sm: 2,
        md: 6
      },
      paddingY: {
        xs: 6,
        sm: 6,
        md: 12
      },
      flexDirection: {
        xs: 'column',
        sm: 'column',
        md: 'row'
      }
    })]
  }, ___EmotionJSX(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      maxWidth: '100%',
      top: 124,
      width: {
        xs: '100%',
        sm: '100%',
        md: '350px'
      },
      position: {
        xs: 'unset',
        sm: 'unset',
        md: 'sticky'
      }
    }
  }, ___EmotionJSX(ArticleHeader, {
    tags: article.tags
  }), ___EmotionJSX(ArticleTableOfContents, null)), ___EmotionJSX(Box, {
    component: "hr",
    sx: {
      border: 'none',
      borderLeft: '1px dashed',
      color: theme => theme.palette.neutral.mediumGray,
      alignSelf: 'stretch',
      display: {
        xs: 'none',
        sm: 'none',
        md: 'initial'
      }
    }
  }), ___EmotionJSX(ArticleBodyWithToc, null, children)))), related.length > 0 && ___EmotionJSX(Section, {
    backgroundColor: "light-gray"
  }, ___EmotionJSX(SectionContentArticles, {
    heading: "You might be interested in",
    articles: related
  })), article.metrics && ___EmotionJSX(Section, {
    backgroundColor: article.metrics.background,
    padding: article.metrics.padding
  }, ___EmotionJSX(SectionContentMetrics, {
    id: `${article.slug}-metrics`,
    heading: article.metrics.heading,
    metrics: article.metrics.items.map((item, i) => ({
      id: `${article.slug}-metric-${i}`,
      heading: item.label,
      value: item.value,
      format: item.format
    }))
  })), ___EmotionJSX(Footer, null));
};
const ogUrl = (image, seoImage) => {
  const id = seoImage || (image === null || image === void 0 ? void 0 : image.publicId);
  return id ? cloudinaryImage(id).toURL() : undefined;
};
export const Head = ({data, location}) => {
  const article = data.mdx.frontmatter;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CommonHead, {
    title: article.seoTitle || article.headline,
    description: article.seoDescription || article.description,
    url: data.site.siteMetadata.siteUrl + location.pathname,
    image: ogUrl(article.heroImage, article.seoImage),
    type: "article"
  }), ___EmotionJSX(StructuredData, {
    schema: generateStructuredDataForArticle(article, location.pathname)
  }));
};
const query = "1833746314";
ArticleTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ArticleTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
